<template>
  <div class="addPackageWrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput label="Сумма лимита" :value="formData.material_sum_limit" allow-negative="false" type="number"
          @change_input="(value) => onChange('material_sum_limit', value)" style="width: 100%;" suffix="₸" />
      </div>

      <CustomModalFooter :btn-loading="loading" submit-btn-text="Сохранить" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "add-project-limit",
  components: { CustomInput, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      formData: {
        material_sum_limit: this.data?.body?.material_sum_limit || 0,
      },
    };
  },
  methods: {
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;

      const payload = {
        project_id: this.data?.body?.project_id,
        material_sum_limit: parseFloat(this.formData.material_sum_limit),
      };
      await this.data?.onSubmit(payload);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 700px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
